export default {
  make: data => ({
    header: `Датчики для ${data.make}`,
    header_uk: `Купити датчики для ${data.make}`,
  }),
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik.js